import { siteConfig } from "../../siteConfig";

interface AppDownloadButtonsProps {
  className?: string;
  size?: "small" | "medium" | "large";
  layout?: "vertical" | "horizontal";
}

export default function AppDownloadButtons({
  className = "",
  size = "large",
  layout = "vertical",
}: AppDownloadButtonsProps) {
  const sizeConfig = {
    small: { width: 164, height: 55 },
    medium: { width: 205, height: 68 },
    large: { width: 246, height: 82 },
  };

  const { width, height } = sizeConfig[size];

  const containerClasses =
    layout === "horizontal"
      ? `flex flex-row gap-3 justify-center ${className}`
      : `flex flex-col gap-4 w-full items-center ${className}`;

  return (
    <div className={containerClasses}>
      <a href={siteConfig.iosAppStoreUrl} style={{ display: "inline-block" }}>
        <img
          src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1751068800"
          alt="Download on the App Store"
          style={{
            width,
            height,
            verticalAlign: "middle",
            objectFit: "contain",
          }}
        />
      </a>
      <a
        href={siteConfig.androidPlayStoreUrl}
        style={{ display: "inline-block" }}
      >
        <img
          src="/images/google-play-badge.png"
          alt="Get it on Google Play"
          style={{
            width,
            height,
            verticalAlign: "middle",
            objectFit: "contain",
          }}
        />
      </a>
    </div>
  );
}
